import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/auth';
import ErrorState from '../common/ErrorState';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
  fallbackPath?: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  allowedRoles,
  fallbackPath = '/',
}) => {
  const { role, hasRole } = useAuth();

  if (!hasRole(...allowedRoles)) {
    if (role === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    if (role === 'agency') {
      return <Navigate to="/agency" replace />;
    }
    return (
      <ErrorState
        title="دسترسی غیرمجاز"
        description="شما مجوز دسترسی به این بخش را ندارید."
        onRetry={() => {
          window.location.href = fallbackPath;
        }}
      />
    );
  }

  return <>{children}</>;
};

export default RoleGuard;
